import React from "react";
import logo from "../../../../assets/logoa 1.png";
import { useState, useEffect, useContext } from "react";
import {
  getAllZones,
  getAllDoccument,
  getDescriptions,
  getMoreDescriptions,
  getPoints,
  getSheetDesc,
  getSheetId,
  sheetInfo,
} from "../../../../services/kojaServices";
import Estate from "./Estate";
import { expertContext } from "../../../../context/expertcontext";
import Description from "./Description";
import MoreDes from "./MoreDes";
import PointsPage from "./Points";
import Areay from "./Areay";
import Final from "./Final";
import Preview from "./preview/Preview";
import FinalRegistration from "./FinalRegistration";
import { FaRegTimesCircle } from "react-icons/fa";

const EditSheet = ({ item , type , setSelected}) => {
  const [zones, setZones] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [description, setDescriptionn] = useState([]);
  const [moreDescription, setMoreDescription] = useState([]);
  const [Points, setPoints] = useState([]);
  const [sheetDesc, setSheetDesc] = useState([]);
  const [sheetId, setSheetID] = useState([]);
  const [info, setInfo] = useState({});

  const {
    tab,
    setAttributes,
    setAttributes2,
    setAttributes3,
    setImgName,
    setAreaInfo,
    setDescription,
    setEstate,
    setTab,
  } = useContext(expertContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if(type ===2 ){
          const { data: zones } = await getAllZones();
        setZones(zones.result);
        const { data: documents } = await getAllDoccument();
        setDocuments(documents.result);
        const { data: description } = await getDescriptions();
        setDescriptionn(description.result);
        const { data: more } = await getMoreDescriptions();
        setMoreDescription(more.result);
        const { data: points } = await getPoints();
        setPoints(points.result);
        const { data: sheetDesc } = await getSheetDesc();
        setSheetDesc(sheetDesc.result);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [type]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (item.requestToken?.length > 2 && type ===2) {
          const { data: sheetID } = await getSheetId({
            requestToken: item.requestToken,
          });
          setSheetID(sheetID.result.sheetId);
          const { data } = await sheetInfo(sheetID.result.sheetId);
          console.log(data)
          setInfo(data.result);
          const info = data.result;
          let attr1 = [];
          let attr2 = [];
          let attr3 = { aryy: [] };
          info.attributes.map((i, index) => {
            if (i.type === "Property") {
              attr1.push(i);
            } else if (i.type === "Other") {
              attr2.push(i);
            } else if (i.type === "Facilities") {
              attr3.attributes = { ...i };
            } else if (i.type === "Score") {
              attr3.aryy.push(i);
            }
          });
          setAttributes(attr1);
          setAttributes2(attr2);
          setAttributes3(attr3);
          setImgName(info.sheetFile.name);
          setAreaInfo(info.sheetInfo.Ex_Area);
          setDescription(info.sheetInfo?.description);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [item, type]);

  const closeModal = () => {
    setEstate({})
    setAttributes([]);
    setAttributes2([]);
    setAttributes3({});
    setImgName("");
    setAreaInfo({});
    setDescription();
    setTab(1);
    setSelected({})
  };

  return (
    <div>
      <div
        className="modal fade "
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog" style={{ maxWidth: "90%" }}>
          <div className="modal-content sabtKarshenasi-modalbox">
            <div className=" px-3">
              <div className=" text-end">
                <button
                  className="btn p-0"
                  style={{ color: "#EF971C", fontSize: "30px" }}
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  <FaRegTimesCircle />
                </button>
              </div>
              <div className="karshenasi-header-box mb-2">
                <div className="d-flex  flex-column flex-md-row justify-content-between align-items-center">
                  <h5 style={{ textAlign: "right" }}>ویرایش صورت کارشناسی</h5>
                  <img
                    alt="logo"
                    className="karshenasi-logo d-none d-md-block"
                    src={logo}
                  />
                  <div className="d-flex  flex-column flex-md-row justify-content-between">
                    <p>تاریخ : {Intl.DateTimeFormat("fa-IR").format(new Date())} &nbsp;&nbsp;</p>
                    <p className="">شماره : {item.requestToken}</p>
                  </div>
                </div>
                <div className="mt-1 d-flex flex-column flex-md-row justify-content-between align-items-center">
                  <p>نام ونام خانوادگی: {item.Ex_Owner?.name}</p>
                  <p>شماره تماس : {item.Ex_Owner?.tel}</p>
                  <p>
                    تاریخ درخواست:{" "}
                    {item.expert &&
                      item.expert[0]?.Ex_Expertors.faDateTime
                        .split(" ")[0]
                        .replaceAll("-", "/")}
                  </p>
                </div>
              </div>
              <p style={{ fontWeight: "bolder", color: "#FFDA94" }}>
                {" "}
                *کارشناس محترم برای ثبت اطلاعات در هر مرحله لطفا از دکمه "بعدی"
                استفاده کنید *
              </p>
            </div>

          {
            type === 2 &&  <div className="my-2 px-3">
            {tab === 1 ? (
              <Estate info={info} zones={zones} documents={documents} />
            ) : tab === 2 ? (
              <Description description={description} />
            ) : tab === 3 ? (
              <MoreDes description={moreDescription} />
            ) : tab === 4 ? (
              <PointsPage points={Points} />
            ) : tab === 5 ? (
              <Areay
                info={info}
                sheetId={sheetId}
                points={Points}
                id={item.id}
                token={item.requestToken}
              />
            ) : tab === 6 ? (
              <Final desc={sheetDesc} />
            ) : tab === 7 ? (
              <Preview item={item} info={info} />
            ) : tab === 8 ? (
              <FinalRegistration info={info} sheetId={sheetId} item={item} />
            ) : (
              ""
            )}
          </div>
          }
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSheet;
